import { render, staticRenderFns } from "./BondenWarehouseList.vue?vue&type=template&id=5857a980&scoped=true"
import script from "./BondenWarehouseList.vue?vue&type=script&lang=js"
export * from "./BondenWarehouseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5857a980",
  null
  
)

export default component.exports